import React from 'react';
import ig from '../../assets/logo/socials/instagram.svg';
import x from '../../assets/logo/socials/x.svg';
import tiktok from '../../assets/logo/socials/tiktok.svg';
import whatsapp from '../../assets/logo/socials/whatsapp.svg';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className='flex flex-col justify-center items-center bg-deepgreen lg:p-[75px] p-5 rounded-t-[20px] border-t-[6px] border-l-[6px] border-r-[6px] border-offblack'>

      <p className="font-chido text-offwhite lg:text-[24px] text-[16px]">JOIN THE MOVEMENT</p>

      <div className="flex justify-center items-center gap-3 lg:mt-[30px] mt-5">

        <a href="https://www.instagram.com/lafriendzonelome" target="_blank" rel="noreferrer" className="flex justify-center items-center bg-offblack rounded-full lg:w-[80px] lg:h-[80px] w-[50px] h-[50px]">
          <img className='lg:w-[34px] lg:h-[34px] w-5 h-5' src={ig} alt="" />
        </a>

        <a href="https://www.tiktok.com/@friendzonelome" target="_blank" rel="noreferrer" className="flex justify-center items-center bg-offblack rounded-full lg:w-[80px] lg:h-[80px] w-[50px] h-[50px]">
          <img className='lg:w-[34px] lg:h-[34px] w-5 h-5' src={tiktok} alt="" />
        </a>

        <a href="https://whatsapp.com/channel/0029VatuwLjCRs1fy5WfjL2Q" target="_blank" rel="noreferrer" className="flex justify-center items-center bg-offblack rounded-full lg:w-[80px] lg:h-[80px] w-[50px] h-[50px]">
          <img className='lg:w-[34px] lg:h-[34px] w-5 h-5' src={whatsapp} alt="" />
        </a>

        <a href="https://x.com/friendzonelome" target="_blank" rel="noreferrer" className="flex justify-center items-center bg-offblack rounded-full lg:w-[80px] lg:h-[80px] w-[50px] h-[50px]">
          <img className='lg:w-[34px] lg:h-[34px] w-5 h-5' src={x} alt="" />
        </a>

      </div>

      <div className="flex lg:flex-row flex-col justify-between items-center lg:mt-[60px] mt-10 lg:gap-[30px] gap-5 lg:text-[20px] text-[14px] font-concretica text-offwhite">
        <Link to={'https://wearebiam.com/tcs'} target="_blank" rel="noreferrer" className=''>Terms & Conditions</Link>
        {/* <a href="http://" className=''>Press & Brand Kit</a> */}
      </div>

      <p className="flex justify-between items-center lg:mt-[60px] mt-[80px] lg:gap-[30px] text-[14px] font-concretica text-offwhite">© BIAM Entertainment Group 2025</p>

    </div>
  )
}

export default Footer